import { useQuery } from '@tanstack/react-query'
import * as R from 'remeda'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { applyIfExist } from '~/utils'

import { useSurveyId } from '../useSurveyId'

import { useMainQueryKey } from './useMainQueryKey'

const document = graphql(`
  query DataSettingsPage_Main($surveyId: String!) {
    getUploadedFilesProperties(surveyId: $surveyId) {
      questionnaire {
        filename
        extension
        size
      }
      answer {
        filename
        extension
        size
      }
    }
  }
`)

export const useMainQuery = () => {
  const graphQLRequest = useGraphQLRequest()
  const surveyId = useSurveyId()
  const queryKey = useMainQueryKey()

  return useQuery({
    queryFn: async () => {
      const result = await graphQLRequest({ document, variables: { surveyId } })

      return R.pipe(
        result.getUploadedFilesProperties,
        applyIfExist((uploadedFilesProperties) => ({
          ...uploadedFilesProperties,
          questionnaire: R.pipe(
            uploadedFilesProperties.questionnaire,
            (questionnaire) => ({
              ...questionnaire,
              filename: questionnaire.filename ?? undefined,
              extension: questionnaire.extension ?? undefined,
              size: questionnaire.size ?? undefined,
            }),
          ),
          answer: R.pipe(uploadedFilesProperties.answer, (answer) => ({
            ...answer,
            filename: answer.filename ?? undefined,
            extension: answer.extension ?? undefined,
            size: answer.size ?? undefined,
          })),
        })),
      )
    },
    queryKey,
  })
}

export type UploadedFilesProperties = NonNullable<
  QueryResultOf<typeof useMainQuery>
>
